import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { Months } from "src/app/core/Enums/MonthsEnum";
import { RiskStatus } from "src/app/core/Enums/RiskStatus";
import { PdfService } from "src/app/core/helpers/pdf.service";
import { AuthenticationService } from "src/app/core/services/auth.service";
import { GenericService } from "src/app/core/services/generic.service";
import { GenericActivityService } from "src/app/core/services/Index-Generic-activity/generic-activity.service";

@Component({
  selector: "app-specific-risk-assessment-index",
  templateUrl: "./specific-risk-assessment-index.component.html",
  styleUrls: ["./specific-risk-assessment-index.component.scss"],
})
export class SpecificRiskAssessmentIndexComponent implements OnInit {
  VesselHistorylist: any;
  queryString: string;
  text: any = "";
  RiskStatusEnum = RiskStatus;
  riskStatusList: { key: string, value: number }[] = [];
  MonthList = Object.values(Months);
  showRaId = [{ key: 'Yes', value: true }, { key: 'No', value: false }];
  public IsRaId: boolean = true;
  public defaultMonth = 'All';
  public selectedStatus: number;
  vessel: any;
  QueryParamObj: any = {
    Month: "",
    Vesselid: "",
    Status: "",
  };
  constructor(
    private GenericActivity: GenericActivityService,
    private spinner: NgxSpinnerService,
    private pdfService: PdfService,
    private apiService: GenericService,
    public auth: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.VHById("All");
    this.onGetVessel();
    this.prepareRiskStatusList();
  }

  prepareRiskStatusList() {
    this.riskStatusList = Object.keys(RiskStatus).map(key => ({
      key: key,
      value: RiskStatus[key as keyof typeof RiskStatus]
    }));
  }

  VHById(event: any, type?: string) {
    if (type == "month") {
      if (event == undefined || event == "All") this.QueryParamObj.Month = "";
      else this.QueryParamObj.Month = event;
      this.spinner.show();
    }
    if (type == "vesselId") {
      if (event == undefined || event == "All")
        this.QueryParamObj.Vesselid = "";
      else this.QueryParamObj.Vesselid = event.id;
      this.spinner.show();
    }
    if (type === "status") {
      if (event == undefined || event == "All") {
        this.QueryParamObj.Status = "";
      } else {
        this.QueryParamObj.Status = event.value; // Ensure you get the correct value here
      }
      this.spinner.show();
    }

    this.queryString =
      "month=" +
      this.QueryParamObj.Month +
      "&vesselId=" +
      this.QueryParamObj.Vesselid +
      "&status=" +
      this.QueryParamObj.Status;
    this.GenericActivity.vesselHistoryById(this.queryString).subscribe(
      (res: any) => {
        if (res.statusCode == 200) {
          this.spinner.hide();
          this.text = event;
          this.VesselHistorylist = this.monthData(res.data);
          this.VesselHistorylist = this.filterByStatus(this.VesselHistorylist);
        } else {
          this.spinner.hide();
          this.VesselHistorylist = [];
          // this.VesselHistorylist = [];
        }
      }
    );
  }

  filterByStatus(data: any) {
    if (!this.selectedStatus) return data; // Make sure this is not filtering out incorrectly
    return data.filter(item => item.status === this.selectedStatus);
  }


  PrintPdf() {
    this.pdfService.printPdf("VesselHistoryReport");
  }

  downloadPdf() {
    this.pdfService.convertToPdf("VesselHistoryReport", "VesselHistoryReport"); // name for pdf will be changed once we get dynamic data
  }

  monthData(data: any) {
    let vesselHistory: any = [];
    let vesselsList = [];
    data.forEach((element) => {
      element.riskAssisment.forEach((el) => {
        el.vesselId = element.id;
        el.vesselName = element.vessel;
      });
      var RA = element.riskAssisment.map((c) => c);
      RA.forEach((item) => {
        vesselHistory.push(item);
      });
    });
    vesselHistory.forEach((element) => {
      var month = new Date(element.createdAt).getMonth();
      if (vesselsList[month]) {
        let index = vesselsList[month].RAlist.findIndex(
          (x) => x.vesselName == element.vesselName
        );
        if (index >= 0) {
          element.vessel = element.vesselName;
          vesselsList[month].RAlist[index].data.push(element);
        } else {
          element.vessel = element.vesselName;
          vesselsList[month].RAlist.push({
            vesselName: element.vesselName,
            data: [element],
          });
        }
      } else {
        vesselsList[month] = { RAlist: [], RACount: 0 };
        vesselsList[month].RAlist.push({
          vesselName: element.vesselName,
          data: [element],
        });
      }
    });
    vesselsList.forEach((item) => {
      item.RAlist.forEach((element) => {
        item.RACount += element.data.length;
      });
    });
    return vesselsList;
  }

  onGetVessel() {
    this.apiService.Get(`vessel/get-list`).subscribe((res: any) => {
      this.vessel = res.data.sort((a, b) => a.vessel.localeCompare(b.vessel));
    });
  }

  onChange(event) {

    this.IsRaId = event.value;
  }

  onStatusChange(event: any) {
    this.selectedStatus = event?.value;
    this.VHById(this.selectedStatus, "status");
  }

}
